// @flow
import { forwardRef } from 'react';
import GatsbyLink from 'gatsby-link';
import { OutboundLink } from 'gatsby-plugin-gtag';

type PropsType = { to: string };

const AlteredGatsbyLink = forwardRef<PropsType, HTMLAnchorElement>(
  ({ to, ...props }: PropsType, ref: *) => {
    const isExternal = to.match(/^https?:\/\//);
    if (isExternal) {
      return <OutboundLink {...props} href={to} />;
    }
    return <GatsbyLink {...props} to={to} ref={ref} />;
  }
);

export default AlteredGatsbyLink;
